
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Layout
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Payments from './pages/Payments';
import Analytics from './pages/Analytics';
import Platforms from './pages/Platforms';
import HistoricalSync from './pages/HistoricalSync';
import ShopifyPayouts from './pages/ShopifyPayouts';
import Settings from './pages/Settings';
import CategorizationRules from './pages/CategorizationRules';
import QuickBooksFinancials from './pages/QuickBooksFinancials';
import TrueCash from './pages/TrueCash';
import MembershipLayers from './pages/MembershipLayers';
import PostSchoolSales from './pages/PostSchoolSales';
import SP30Cohorts from './pages/SP30Cohorts';
import NewCustomerCohorts from './pages/NewCustomerCohorts';
import FirstProductLTV from './pages/FirstProductLTV';
import ClubBuyers from './pages/ClubBuyers';
import BusinessLines from './pages/BusinessLines';
import CreditCardUsage from './pages/CreditCardUsage';
import CallawayDashboard from './pages/CallawayDashboard';
import Customers from './pages/Customers';
import KeapOrders from './pages/KeapOrders';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/payments" element={
              <ProtectedRoute>
                <Layout>
                  <Payments />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/platforms" element={
              <ProtectedRoute>
                <Layout>
                  <Platforms />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/historical-sync" element={
              <ProtectedRoute>
                <Layout>
                  <HistoricalSync />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/shopify-payouts" element={
              <ProtectedRoute>
                <Layout>
                  <ShopifyPayouts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials" element={
              <ProtectedRoute>
                <Layout>
                  <QuickBooksFinancials />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/true-cash" element={
              <ProtectedRoute>
                <Layout>
                  <TrueCash />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/business-lines" element={
              <ProtectedRoute>
                <Layout>
                  <BusinessLines />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/membership" element={
              <ProtectedRoute>
                <Layout>
                  <MembershipLayers />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/post-school" element={
              <ProtectedRoute>
                <Layout>
                  <PostSchoolSales />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/sp30" element={
              <ProtectedRoute>
                <Layout>
                  <SP30Cohorts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/new-customers" element={
              <ProtectedRoute>
                <Layout>
                  <NewCustomerCohorts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/first-product-ltv" element={
              <ProtectedRoute>
                <Layout>
                  <FirstProductLTV />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/club-buyers" element={
              <ProtectedRoute>
                <Layout>
                  <ClubBuyers />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/credit-cards" element={
              <ProtectedRoute>
                <Layout>
                  <CreditCardUsage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/keap-orders" element={
              <ProtectedRoute>
                <Layout>
                  <KeapOrders />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financials/callaway" element={
              <ProtectedRoute>
                <Layout>
                  <CallawayDashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/customers" element={
              <ProtectedRoute>
                <Layout>
                  <Customers />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/categorization" element={
              <ProtectedRoute>
                <Layout>
                  <CategorizationRules />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;